module.exports = __webpack_public_path__ + "static/media/4ODA7.7ec7f46e.jpg";